import React from "react";

const Badge = ({ text, styleColor, onClick }) => {

    const getStyleFromValue = (styleColor) => {
        switch (styleColor) {
            case "primary":
                return {
                    background: "var(--primary-light)",
                    color: "var(--primary-base)",
                    borderColor: "#904FED33"
                };
            case "green":
                return {
                    background: "#00C45B1A",
                    color: "var(--green-base)",
                    borderColor: "#00C45B33"
                };
            case "grey":
                return {
                    background: "var(--grey-lighter)",
                    color: "var(--grey-base)",
                    borderColor: "var(--grey-light)"
                };
            case "red":
                return {
                    background: "#FF002E1A",
                    color: "var(--red-base)",
                    borderColor: "#FF002E4D"
                };
            case "paleRed":
                return {
                    background: "#FF002E99",
                    color: "#FFB3C1",
                    borderColor: "#FFB3C1"
                };
            default:
                return {
                    background: "transparent",
                    color: "inherit",
                    borderColor: "transparent"
                };
        }
    };

    const styles = getStyleFromValue(styleColor);


    return (
        <div className="badge-container" style={{
            backgroundColor: styles.background,
            color: styles.color,
            border: `1px solid ${styles.borderColor}`
        }}
        onClick={onClick}>
            {text}
        </div>
    );
};

export default Badge;
